import { useInitUpc, useUpc } from '@common-vue/media-card-large';
import { computed } from 'vue';
import { useProductType } from '@composables/useProductType';
import { toTraitId } from '../utils/utils';

/**
 * @param {string} id
 * @param {LatchkeyName[]} latchkeyNames
 * @param {Record<string, ParsedColors>} latchkeyUpcMap
 */
function useInitEachUpc(id, latchkeyNames, latchkeyUpcMap) {
  latchkeyNames.forEach((latchkeyName) => {
    const upcMap = latchkeyUpcMap[latchkeyName];
    useInitUpc({ id: toTraitId(id, latchkeyName), data: upcMap });
  });
}

/**
 * @typedef UpcInfo
 * @property {import('vue').ComputedRef<boolean>} hasSelectedUpcId
 * @property {import('vue').ComputedRef<boolean>} hasSelectedUpcNumber
 * @property {import('vue').ComputedRef<string>} selectedUpcNumber
 * @property {import('vue').ComputedRef<number | undefined>} selectedUpcId
 * @property {import('@common-vue/media-card-large/src/composables/useUpc/types').UseUpc.UpcData} upcData
 */

// TODO fix return type
/**
 * @param {string} id
 * @param {import('vue').DeepReadonly<import('vue').Ref<LatchkeyName>>} selectedLatchkey
 * @param {ParsedLatchkeys} parsedLatchkeyData
 */
export default function useLatchkeyUpc(id, selectedLatchkey, { latchkeyNames, latchkeyUpcMap }) {
  const { isConsolidatedLatchKey } = useProductType();

  if (isConsolidatedLatchKey) {
    useInitEachUpc(id, latchkeyNames, latchkeyUpcMap);

    const traitId = computed(() => toTraitId(id, selectedLatchkey.value));
    const {
      hasSelectedUpcId, hasSelectedUpcNumber, selectedUpcNumber, selectedUpcId, upcData,
    } = useUpc(traitId);

    return {
      hasSelectedUpcId,
      hasSelectedUpcNumber,
      selectedUpcNumber,
      selectedUpcId,
      upcData,
    };
  }

  return {
    hasSelectedUpcId: computed(() => false),
    hasSelectedUpcNumber: computed(() => false),
    selectedUpcNumber: computed(() => ''),
    selectedUpcId: computed(() => undefined),
    upcData: computed(() => ({})),
  };
}
